import React from 'react'
import { withTranslation } from 'react-i18next'
import YearMonth from './YearMonth'
import DaysOfTheWeek from './DaysOfTheWeek'
import Weeks from './Weeks'
import './style.css'

const Calendar = ({ t }) => {
  return (
    <div>
      <section className="Calendar" aria-label={t('calendar_schedular.calendar')}>
        <YearMonth />
        <div className="Calendar-grid">
          <DaysOfTheWeek />
          <Weeks />
        </div>
      </section>
    </div>
  )
}

export default withTranslation('common')(Calendar)
